import type { ArticleTeaser } from '@/types';

/**
 * English article cards.
 *
 * The articles themselves are NOT hosted here: the translations are published
 * on the Asterion blog, and every card links straight to them. Titles, excerpts
 * and categories are copied verbatim from that blog so both sites match.
 * Order and reading times follow the French list, which stays the reference.
 */
export const ARTICLE_TEASERS: ArticleTeaser[] = [
  {
    slug:       'notre-approche-qualite-pme-manufacturiere',
    title:      'My approach to quality in small manufacturing companies: seven principles',
    category:   'MY APPROACH',
    excerpt:    'A feature list says nothing: every quality software package handles non-conformities and calibrations. What separates two tools is what their authors believe. Here are the seven principles on which everything we build rests…',
    readingMin: 13,
    href:       'https://solutions-asterion.com/en/blog/notre-approche-qualite-pme-manufacturiere',
    isExternal: true,
  },
  {
    slug:       'structurer-demarche-qualite-pme-manufacturiere',
    title:      'Structuring quality management in a small manufacturer: the complete guide',
    category:   'GUIDE',
    excerpt:    'Quality isn\'t decided on audit day but in six daily moves: seeing a problem, knowing where it came from, handling it in time, heading it off, deciding on numbers, closing the loop. This guide is the map — one section per axis, and where to read on…',
    readingMin: 14,
    href:       'https://solutions-asterion.com/en/blog/structurer-demarche-qualite-pme-manufacturiere',
    isExternal: true,
  },
  {
    slug:       'rendre-iso-9001-accessible-pme-ia',
    title:      'Making ISO 9001 accessible to small shops: the realistic role of AI',
    category:   'QUALITY & MANUFACTURING SMES',
    excerpt:    'ISO 9001 has a reputation for being reserved for companies that can afford a full-time quality engineer or a consultant on retainer. For many small manufacturing…',
    readingMin: 14,
    href:       'https://solutions-asterion.com/en/blog/rendre-iso-9001-accessible-pme-ia',
    isExternal: true,
  },
  {
    slug:       'cout-cache-temps-machiniste-rapports-inspection',
    title:      'Inspection reports: the real hidden cost of machinist time',
    category:   'INSPECTION & QUALITY CONTROL',
    excerpt:    'In a machine shop, the inspection report isn\'t paperwork: it\'s a mandatory deliverable demanded by the customer, on the same footing as the part itself. Without…',
    readingMin: 12,
    href:       'https://solutions-asterion.com/en/blog/cout-cache-temps-machiniste-rapports-inspection',
    isExternal: true,
  },
  {
    slug:       'revue-direction-iso-9001-sans-consultant',
    title:      'Running your ISO 9001 management review without a consultant',
    category:   'ISO QUALITY SYSTEM',
    excerpt:    'The management review (clause 9.3) is the ISO 9001 exercise small shops dread the most: once a year, leadership has to sit down, look its quality system in the…',
    readingMin: 12,
    href:       'https://solutions-asterion.com/en/blog/revue-direction-iso-9001-sans-consultant',
    isExternal: true,
  },
  {
    slug:       'points-critiques-systeme-qualite',
    title:      'Seeing the weak points in your quality system at a glance',
    category:   'AUDIT & MAPPING',
    excerpt:    'An ISO 9001 quality system isn\'t a stack of folders. It\'s a network: a nonconformity points to a process, a corrective action points to that nonconformity, an…',
    readingMin: 11,
    href:       'https://solutions-asterion.com/en/blog/points-critiques-systeme-qualite',
    isExternal: true,
  },
  {
    slug:       'ecosysteme-pas-silos-bon-de-travail',
    title:      'One ecosystem, not silos: when the work order is entered only once',
    category:   'SHOP-FLOOR DIGITIZATION',
    excerpt:    'In most of the shops I visit, the same work order gets re-entered three, four, five times: once for inspection, once in the quality system, once in the metrology…',
    readingMin: 12,
    href:       'https://solutions-asterion.com/en/blog/ecosysteme-pas-silos-bon-de-travail',
    isExternal: true,
  },
  {
    slug:       'metrologie-hors-excel-etalonnage',
    title:      'Metrology beyond the spreadsheet: never miss a calibration again',
    category:   'METROLOGY',
    excerpt:    'In nearly every machine shop I have visited, the fleet of measuring instruments lives in a spreadsheet. One column for "last calibration date," one for "next," and…',
    readingMin: 11,
    href:       'https://solutions-asterion.com/en/blog/metrologie-hors-excel-etalonnage',
    isExternal: true,
  },
  {
    slug:       'plans-heberges-quebec-loi-25',
    title:      'Your drawings hosted in Canada: what privacy law changes for your shop',
    category:   'DATA SOVEREIGNTY',
    excerpt:    'The drawings your customers entrust to you and the quality history you build up over the years are sensitive assets — every bit as much as your machines. Two…',
    readingMin: 11,
    href:       'https://solutions-asterion.com/en/blog/plans-heberges-quebec-loi-25',
    isExternal: true,
  },
  {
    slug:       'ia-qualite-ce-quelle-peut-faire',
    title:      'AI and quality: what it can do, and what it must never do',
    category:   'AI & QUALITY',
    excerpt:    'Artificial intelligence is arriving on the shop floor, and two camps are squaring off: those who believe it will do everything, and those who believe it will break…',
    readingMin: 11,
    href:       'https://solutions-asterion.com/en/blog/ia-qualite-ce-quelle-peut-faire',
    isExternal: true,
  },
  {
    slug:       'ocr-plans-cotes-manufacturier',
    title:      'OCR on dimensioned drawings: why generic tools fail in manufacturing',
    category:   'TECHNOLOGY & INSPECTION',
    excerpt:    'A dimensioned drawing is not a letter or a contract. It is a dense technical object: dimensions, tolerances, geometric-tolerancing symbols, datum reference frames,…',
    readingMin: 11,
    href:       'https://solutions-asterion.com/en/blog/ocr-plans-cotes-manufacturier',
    isExternal: true,
  },
  {
    slug:       'batir-logiciels-metier-ia-encadree',
    title:      'Building trade-specific software with framed AI: behind the scenes',
    category:   'BEHIND THE SCENES & VISION',
    excerpt:    'I spent fourteen years in quality, several of them doing dimensional inspection in the hydroelectric sector, before I wrote my first serious line of code. Today,…',
    readingMin: 10,
    href:       'https://solutions-asterion.com/en/blog/batir-logiciels-metier-ia-encadree',
    isExternal: true,
  },
  {
    slug:       'logiciel-qualite-usinage-sorel-tracy',
    title:      'Sorel-Tracy, from the turbine to the heavy part: the quality demands of a metallurgical hub',
    category:   'SOREL-TRACY & MONTÉRÉGIE',
    excerpt:    'Sorel-Tracy did not grow up making small production runs. It grew up pouring steel, building heavy fabrications and assembling hydroelectric equipment — turbines,…',
    readingMin: 7,
    href:       'https://solutions-asterion.com/en/blog/logiciel-qualite-usinage-sorel-tracy',
    isExternal: true,
  },
  {
    slug:       'logiciel-qualite-usinage-drummondville',
    title:      'Drummondville: the strength — and the quality headache — of a manufacturer that does a bit of everything',
    category:   'DRUMMONDVILLE & CENTRE-DU-QUÉBEC',
    excerpt:    'Drummondville doesn\'t have one industry, it has ten. Metal, machinery, plastics, furniture, food processing, transportation, and subcontracting for the nearby…',
    readingMin: 7,
    href:       'https://solutions-asterion.com/en/blog/logiciel-qualite-usinage-drummondville',
    isExternal: true,
  },
  {
    slug:       'logiciel-qualite-usinage-trois-rivieres-mauricie',
    title:      'From hydroelectricity to aluminum: a century of industry in the Mauricie, and the quality that comes with it',
    category:   'TROIS-RIVIÈRES & MAURICIE',
    excerpt:    'The Mauricie is the birthplace of hydroelectricity in Quebec. It was at Shawinigan, in the very first years of the twentieth century, that the Saint-Maurice River…',
    readingMin: 7,
    href:       'https://solutions-asterion.com/en/blog/logiciel-qualite-usinage-trois-rivieres-mauricie',
    isExternal: true,
  },
  {
    slug:       'logiciel-qualite-usinage-montreal',
    title:      'Aerospace machining in Greater Montreal: when the proof weighs as much as the part',
    category:   'MONTREAL & GREATER MONTREAL',
    excerpt:    'Greater Montreal is one of the few places in the world where a complete aircraft can be assembled without leaving the region. That aerospace cluster pulls up a…',
    readingMin: 7,
    href:       'https://solutions-asterion.com/en/blog/logiciel-qualite-usinage-montreal',
    isExternal: true,
  },
  {
    slug:       'logiciel-qualite-usinage-saguenay-lac-saint-jean',
    title:      'Saguenay–Lac-Saint-Jean: machining for heavy industry, far from the big centres',
    category:   'SAGUENAY–LAC-SAINT-JEAN',
    excerpt:    'Nowhere else in Quebec is heavy industry so present, so old, and so structuring as in the Saguenay–Lac-Saint-Jean. Aluminum reigns here — but aluminum only exists…',
    readingMin: 8,
    href:       'https://solutions-asterion.com/en/blog/logiciel-qualite-usinage-saguenay-lac-saint-jean',
    isExternal: true,
  },
  {
    slug:       'maturite-systeme-qualite-pme',
    title:      'Is your quality system reactive, or under control?',
    category:   'QUALITY SYSTEM & STEERING',
    excerpt:    'Everyone asks you where you stand, and you answer what everyone answers: "we\'re ISO 9001 certified." True — and it says almost nothing. Here is a five-level maturity scale that fits a shop of thirty…',
    readingMin: 15,
    href:       'https://solutions-asterion.com/en/blog/maturite-systeme-qualite-pme',
    isExternal: true,
  },
  {
    slug:       'innovateur-interne-adoption-logiciel-pme',
    title:      'The innovator you\'re looking for already works for you',
    category:   'TEAM & CHANGE',
    excerpt:    'When software fails to take hold in a machine shop, the software gets the blame. Almost always wrongly. What blocks it is people: the ones on the floor who fear what the tool will reveal about them, and the owner who doesn\'t understand what the person pushing for it is doing. That person already…',
    readingMin: 17,
    href:       'https://solutions-asterion.com/en/blog/innovateur-interne-adoption-logiciel-pme',
    isExternal: true,
  },
  {
    slug:       'rapport-usinage-inspection-quatre-lectures',
    title:      'The machining inspection report: four people, four readings of the same document',
    category:   'INSPECTION REPORT',
    excerpt:    'The machinist sees a chore that casts doubt on a part he knows is good. The inspector, a signature committing him to measurements he didn\'t all take again. The owner, a cost that shows up on no quote. And at the customer\'s end, a reviewer calls go/no-go without ever holding the part. All four are right at once…',
    readingMin: 15,
    href:       'https://solutions-asterion.com/en/blog/rapport-usinage-inspection-quatre-lectures',
    isExternal: true,
  },
  {
    slug:       'jamais-vu-systeme-qualite-pme',
    title:      'In fourteen years, I never saw a quality system in a small shop',
    category:   'OPINION',
    excerpt:    'For fourteen years, I never saw a real quality management system in a small shop. Everywhere, the same homemade assembly — Excel, network folders, the ERP\'s forgotten module — that nobody designed and everybody inherited. And if the person who understands it left tomorrow?…',
    readingMin: 10,
    href:       'https://solutions-asterion.com/en/blog/jamais-vu-systeme-qualite-pme',
    isExternal: true,
  },
];
